/*
 * Proprietary and Confidential
 *
 * Copyright (c) [2018] -  [] Marcelo H. Krebber - Munich, London 2018
 * All Rights Reserved.
 *
 * Dissemination or reproduction of this file [cover-slider.js] or parts within
 * via any medium is strictly forbidden unless prior written permission is obtained
 * from <marcelo.krebber@gmail.com>
 *
 * Last modified: 11.12.19, 12:54
 */
import React, {useState} from 'react';
import {Swiper} from "swiper/react"
import {Autoplay, Navigation, Pagination} from "swiper/modules"
import 'swiper/swiper-bundle.css'
//
// import 'swiper/css';
// import 'swiper/css/pagination';


const SwiperContainer = ({children, lazy = false, slidesPerView = 1, pagination = true,
                            breakpoints = null, autoplay = true, ...otherProps}) => {

    const [modules, setModules] = useState(() => {
        const modules = [Navigation];
        pagination && modules.push(Pagination);
        autoplay && modules.push(Autoplay);
        return modules;
    });

    let params = {
        modules: modules,
        spaceBetween: 15,
        slidesPerView: slidesPerView,
        navigation: true,
        pagination: {clickable: true},
        scrollbar:{draggable: true},
        autoplay:autoplay,
        grabCursor:true,
    }

    if(breakpoints) {
        params = {...params, breakpoints: breakpoints}
    }

    return <Swiper {...params} {...otherProps}>
        {children}
    </Swiper>
}

export default SwiperContainer;